<template>
  <div>
    <BenefitsInfoCard :title="Title" :data="benefits"></BenefitsInfoCard>
  </div>
</template>

<script>
import BenefitsInfoCard from "@/components/employees/benefitsInfoCard.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "benefitsManagement",
  components: {
    BenefitsInfoCard,
  },

  data() {
    return {
      Title: "Benefits Management",
      benefits: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  created() {
    const Id = this.getCurrentEmployeeId;
    this.getBenefits(Id);
  },
  methods: {
    // /{organization}/setup/benefit/v1/request
    getBenefits(id) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      this.loading = true;
      axios
        .get(
          `${this.getOrganization}/setup/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.benefits = response.data.Data;
              this.benefits["employeeId"] = id;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
